/**
 * Macboot Mobile Menu Click Fix v4 (2026-05-14)
 * Minimal interference: just safety navigation if click doesn't work.
 */
(function() {
  'use strict';
  if (window.__macbootMobileMenuFix) return;
  window.__macbootMobileMenuFix = true;

  function moveMenuDrawerToBody() {
    var drawer = document.getElementById('site-menu-sidebar');
    if (!drawer || drawer.parentElement === document.body) return;
    document.body.appendChild(drawer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', moveMenuDrawerToBody, { once: true });
  } else {
    moveMenuDrawerToBody();
  }

  function getMenuLink(el) {
    if (!el || !el.closest) return null;
    var link = el.closest('a[href]');
    if (!link) return null;
    var drawer = link.closest('sidebar-drawer, .sidebar');
    if (!drawer) return null;
    if (link.hasAttribute('data-js-close')) return null;
    if (link.classList.contains('submenu-back')) return null;
    if (link.closest('.submenu-back')) return null;
    if (link.hasAttribute('aria-expanded')) return null;
    var href = link.getAttribute('href');
    if (!href || href === '#' || href.startsWith('javascript:')) return null;
    // Only same-origin
    try {
      var url = new URL(link.href, window.location.origin);
      if (url.origin !== window.location.origin) return null;
    } catch (e) { return null; }
    return link;
  }

  // Listen passively without stopping propagation. After 200ms check if we navigated.
  document.addEventListener('click', function(e) {
    var link = getMenuLink(e.target);
    if (!link) return;
    var hrefBefore = window.location.href;
    var targetHref = link.href;
    setTimeout(function() {
      if (window.location.href === hrefBefore && targetHref !== hrefBefore) {
        window.location.href = targetHref;
      }
    }, 200);
  }, false);

  // Also listen to touchend in case the click event doesn't fire on mobile due to handlers
  document.addEventListener('touchend', function(e) {
    var link = getMenuLink(e.target);
    if (!link) return;
    var hrefBefore = window.location.href;
    var targetHref = link.href;
    setTimeout(function() {
      if (window.location.href === hrefBefore && targetHref !== hrefBefore) {
        window.location.href = targetHref;
      }
    }, 300);
  }, { passive: true });
})();
